























import { defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'CookieConsent',
  components: {
    SfButton,
  },
  setup() {
    const { app } = useContext();
    // @ts-ignore
    const cookieConsent = app.$vsf.$magento.config.state.getCookieConsent();
    const cookieOption = ref(cookieConsent);
    const handleCookieConsent = (option: string) => {
      // @ts-ignore
      app.$vsf.$magento.config.state.setCookieConsent(option);
      cookieOption.value = option;
    };
    return {
      cookieOption,
      handleCookieConsent,
    };
  },
});
